import { toast } from "react-toastify";
import { generateShortURL } from "../../services/api/collaboration";
import { CollaborationApplication } from "../../types/collaborations/CollaborationTypes";
import ClickableImage from "../misc/ClickableImage";
import React from "react";
import { Link } from "react-router-dom";

const CollaborationCard: React.FC<{
    collaborationApplication: CollaborationApplication,
    viewInsights: (campaignId: string) => void,
    uploadWork: (campaignId: string) => void
}> = ({ collaborationApplication, viewInsights, uploadWork }) => {

    const posts = collaborationApplication.collaboration?.posts ?? [];

    const copyURL = async () => {
        try {
            let url = collaborationApplication.collaboration?.landing_page_short_url;
            if (!url) {
                return false;
                // url = await generateShortURL(collaborationApplication.campaign.uuid);
            }
            await navigator.clipboard.writeText(url);
            toast.success("URL copied to your clipboard! 🙂")
        } catch (error) {
            console.error('Failed to copy url');
            console.log(error);
        }
    }


    return (
        <React.Fragment>
            <div className="card card-style mb-3">
                <div className="card-body p-0">
                    <div className="content">
                        <ClickableImage imageURL={collaborationApplication.campaign.hero_img_url} path={`/campaign/${collaborationApplication.campaign.uuid}`} />
                        <div className="d-flex flex-row mb-1 justify-content-between">
                            <span className="text-gray-600" style={{ textTransform: "uppercase" }}>applied {collaborationApplication.applied_on}</span>
                            {
                                collaborationApplication.status === 'pending' &&
                                <span className="chip chip-s bg-gray-light">
                                    <i className="fa fa-check bg-highlight color-white"></i>
                                    <strong className="color-black font-400">Applied</strong>
                                </span>
                            }
                            {
                                collaborationApplication.status === 'accepted' &&
                                <span className="chip chip-s bg-gray-light">
                                    <i className="fa fa-check bg-success color-white"></i>
                                    <strong className="color-black font-400">Accepted</strong>
                                </span>
                            }
                            {
                                collaborationApplication.status === 'rejected' &&
                                <span className="chip chip-sm bg-gray-light">
                                    <i className="fa fa-times bg-red-dark color-white"></i>
                                    <strong className="color-black font-400">Declined</strong>
                                </span>
                            }
                        </div>
                        <h4>{collaborationApplication.campaign.name}</h4>
                        {
                            collaborationApplication.status === 'accepted' &&
                            <Link to={{pathname: `/collaborations/${collaborationApplication.campaign.uuid}`}} className="btn btn-xxs rounded-sm btn-primary w-100 mt-2">View Collaboration</Link>
                        
                        }
                        {/* {
                            collaborationApplication.status === 'accepted' &&
                            collaborationApplication.collaboration &&
                            <div className="d-flex flex-wrap justify-content-between mt-3 mb-4 gap-1">
                                {
                                    (collaborationApplication.collaboration.milestones_count ?? 0) > 0 ?
                                        (
                                            <div>
                                                <Link to={{pathname: `/collaborations/${collaborationApplication.campaign.uuid}`}} className="btn btn-xxs rounded-sm btn-primary me-1">View</Link>
                                            </div>
                                        ) :
                                        (
                                            <div>
                                                {
                                                    posts.length > 0 &&
                                                    collaborationApplication.collaboration.status === 'ongoing' &&
                                                    <button type="button" className="btn btn-xxs rounded-sm btn-primary-outlined me-1" onClick={e => viewInsights(collaborationApplication.campaign.uuid)}>View Insights</button>
                                                }
                                                {
                                                    posts.length > 0 &&
                                                    collaborationApplication.collaboration.status === 'completed' &&
                                                    <button type="button" className="btn btn-xxs rounded-sm btn-primary me-1" onClick={e => viewInsights(collaborationApplication.campaign.uuid)}>View Your Work</button>
                                                }

                                                {
                                                    posts.length === 0 &&
                                                    collaborationApplication.collaboration.status === 'ongoing' &&
                                                    <button type="button" className="btn btn-xxs rounded-sm btn-primary me-1" onClick={e => uploadWork(collaborationApplication.campaign.uuid)}>Upload Your Work</button>
                                                }

                                                {
                                                    posts.length > 0 &&
                                                    collaborationApplication.collaboration.status === 'ongoing' &&
                                                    <button type="button" className="btn btn-xxs rounded-sm btn-primary me-1" onClick={e => uploadWork(collaborationApplication.campaign.uuid)}>Re-upload Your Work</button>
                                                }
                                            </div>
                                        )
                                }

                                {
                                    collaborationApplication.collaboration.status === 'ongoing' && collaborationApplication.collaboration.landing_page_short_url &&
                                    <button type="button" className="btn btn-xxs rounded-sm btn-success-outlined" onClick={e => copyURL()}><i className="fa-solid fa-link"></i></button>
                                }
                            </div>
                        } */}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default CollaborationCard